import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import "../../css/SegwayInfo.css";
import {
  segwayInfoState,
  segwayInfoError,
  segwayInfoLoading,
  segwayInfoUpdatedTime,
  fetchAsyncSegwayInfo,
} from "./SegwayInfoSlice";

import { Link } from "react-router-dom";
//json-server用
import { useCallback } from "react";

const SegwayInfo: React.FC = () => {
  const segwayInfoData = useSelector(segwayInfoState);
  const segwayInfoErrorMsg = useSelector(segwayInfoError);
  const segwayInfoLoadingJudge = useSelector(segwayInfoLoading);
  const segwayInfoGetTime = useSelector(segwayInfoUpdatedTime);
  const dispatch = useDispatch();
  const location = useLocation();
  const { fromPortChange, bodyNumber, fromPort, toPort } =
    (location.state as {
      fromPortChange?: boolean;
      bodyNumber?: string;
      fromPort?: string;
      toPort?: string;
    }) || {};
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [changeItem, setChangeItem] = useState(null);
  const [page, setPage] = useState<number>(1);
  const navigate = useHistory(); //リダイレクト用
  const handlePortChange = (item: any) => {
    setChangeItem(item);
    navigate.push("/Port_change", { state: { item } });
  };

  useEffect(() => {
    if (segwayInfoData === null) {
      dispatch(fetchAsyncSegwayInfo());
    }
  }, [dispatch]);

  useEffect(() => {
    if (fromPortChange) {
      setShouldUpdate(true);
    }
  }, [fromPortChange]);

  useEffect(() => {
    if (shouldUpdate) {
      // ポート変更が成功したら再取得
      dispatch(fetchAsyncSegwayInfo());
      setShouldUpdate(false);
    }
  }, [shouldUpdate]);

  //json-server
  const [segway_info, setSegwayInfo] = useState([]);

  const getSegwayInfo = useCallback(async () => {
    try {
      const res = await fetch("http://localhost:3001/segway_info");
      if (!res.ok) throw new Error("json-serverが起動されていません");
      const json = await res.json();
      setSegwayInfo(json);
    } catch (error) {
      console.error("エラー検出:", error);
    }
  }, []);

  useEffect(() => {
    getSegwayInfo();
  }, [getSegwayInfo]);
  //ここまで

  return (
    <div className="position_row">
      {/* <App className="side_menu" user={user} /> */}
      <div className="segway_info_container">
        {fromPortChange && (
          <div className="log_container">
            <p className="log_message">
              {bodyNumber}を{fromPort}から{toPort}に変更しました。
            </p>
          </div>
        )}
        <h1 className="segway_info_title">キックボード一覧</h1>

        <div className="time">最終更新時間 : {segwayInfoGetTime}</div>
        <Link to="/Port_Info" className="to_port_button">
          ポート一覧へ
        </Link>
        <table className="item_container">
          <thead>
            <tr key={"segway_title"} className="segway_item_container">
              <td className="segway_to_port font_item"></td>
              <td className="segway_id_item font_item">QRコード</td>
              <td className="segway_state_item font_item">IOTコード</td>
              <td className="segway_name_item font_item">車両番号</td>
              <td className="segway_address_item font_item">駐車ポート</td>
              <td className="max_number_item font_item">状態</td>
              <td className="now_number_item font_item">残量</td>
            </tr>
          </thead>
          <tbody>
            {segwayInfoData !== null &&
              segwayInfoData.map((item) => (
                <tr key={item.qrcode} className="segway_item_container">
                  <td
                    className="to_port_item font_item"
                    onClick={() => {
                      handlePortChange(item);
                    }}>
                    ←
                  </td>
                  <td className="segway_id_item font_item">{item.qrcode}</td>
                  <td className="segway_state_item font_item">
                    {item.iotcode}
                  </td>
                  <td className="segway_name_item font_item">
                    {item.body_number}
                  </td>
                  <td className="segway_address_item font_item">
                    {item.port_id} {item.port_name}
                  </td>
                  <td className="max_number_item font_item">
                    {item.mobility_state_id}
                  </td>
                  <td className="now_number_item font_item">
                    {item.energy_per}
                  </td>
                </tr>
              ))}

            {/* json-serve */}
            {/* {segway_info.map((segway_info: any) => (
                  <tr key={segway_info.qrcode} className="segway_item_container">
                    <td
                      className="to_port_item font_item"
                      onClick={() => {
                        handlePortChange(segway_info);
                      }}>
                      ←
                    </td>
                    <td className="segway_id_item font_item">{segway_info.qrcode}</td>
                    <td className="segway_state_item font_item">
                      {segway_info.iotcode}
                    </td>
                    <td className="segway_name_item font_item">
                      {segway_info.body_number}
                    </td>
                    <td className="segway_address_item font_item">
                      {segway_info.port_id} {segway_info.port_name}
                    </td>
                    <td className="max_number_item font_item">
                      {segway_info.mobility_state_id}
                    </td>
                    <td className="now_number_item font_item">
                      {segway_info.energy_per}
                    </td>
                  </tr>
                ))} */}
            {/* json-serve */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SegwayInfo;
